import { InitialMetaData } from "../types/MetaData"

export function isMetaDataNew(localMetaData: InitialMetaData, cloudinaryMetaData: InitialMetaData) {
  const normalizeObject = (obj: InitialMetaData) => {
    return Object.keys(obj).reduce((normalizedObj, key) => {
      const lowerKey = key.toLowerCase() // Convert incoming keys to lowercase
          
      // Exclude 'butik' from comparison
      if (lowerKey !== 'butik') {
        if (lowerKey === 'personkategori') {
          // For personkategori, sort the array and stringify to ensure consistent comparison
          normalizedObj[lowerKey] = JSON.stringify((obj[key] as string[]).map(item => item.toLowerCase()).sort())
        } else {
          // Convert all other values to lowercase
          normalizedObj[lowerKey] = obj[key]?.toLowerCase() || obj[key]
        }
      }
      return normalizedObj
    }, {})
  }

  const normalizedObj1 = normalizeObject(localMetaData)
  const normalizedObj2 = normalizeObject(cloudinaryMetaData)

  // Compare all key-value pairs
  const keys1 = Object.keys(normalizedObj1)
  return keys1.some(key => normalizedObj1[key] !== normalizedObj2[key]) // Return true if any key-value pair is different
}